// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface CalculateDrainagePatternInput
 */
export interface CalculateDrainagePatternInput {
  /**
   *
   */
  dem: RanaFile;
  /**
   *
   */
  minimumCatchmentAreaPercentage?: number;
}

/**
 * Check if a given object implements the CalculateDrainagePatternInput interface.
 */
export function instanceOfCalculateDrainagePatternInput(
  value: object
): value is CalculateDrainagePatternInput {
  if (!("dem" in value) || value["dem"] === undefined) return false;
  return true;
}

export function CalculateDrainagePatternInputFromJSON(json: any): CalculateDrainagePatternInput {
  return CalculateDrainagePatternInputFromJSONTyped(json, false);
}

export function CalculateDrainagePatternInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculateDrainagePatternInput {
  if (json == null) {
    return json;
  }
  return {
    dem: RanaFileFromJSON(json["dem"]),
    minimumCatchmentAreaPercentage:
      json["minimum_catchment_area_percentage"] == null
        ? undefined
        : json["minimum_catchment_area_percentage"],
  };
}

export function CalculateDrainagePatternInputToJSON(json: any): CalculateDrainagePatternInput {
  return CalculateDrainagePatternInputToJSONTyped(json, false);
}

export function CalculateDrainagePatternInputToJSONTyped(
  value?: CalculateDrainagePatternInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    dem: RanaFileToJSON(value["dem"]),
    minimum_catchment_area_percentage: value["minimumCatchmentAreaPercentage"],
  };
}
